/* TR circumference = size + 40 mm; US/UK are nearest reference equivalents,
 * not exact conversions (explicitly labelled). Sources recorded in operations. */
if (!customElements.get('dime-ring-size')) {
  customElements.define('dime-ring-size', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dialog = this.querySelector('dialog');
      this.input = this.querySelector('[data-dime-ring-size]');
      if (!this.dialog || !this.input || typeof this.dialog.showModal !== 'function') return;
      this.trigger = this.querySelector('[data-open-sizes]');
      this.country = this.querySelector('[data-size-country]');
      this.dataset.ready = 'true';
      this.input.required = false;
      this.addEventListener('click', event => this.handleClick(event));
      this.querySelector('[role="tablist"]').addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const current = this.querySelector('[role="tab"][aria-selected="true"]').dataset.sizeTab;
        this.setTab(event.key==='Home'?'sizes':event.key==='End'?'guide':current==='sizes'?'guide':'sizes',true);
      });
      this.country.addEventListener('change', () => this.updateCountry());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.oldOverflow ?? '';
        if (this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll:true});
      });
      this.refreshSelection();
    }
    handleClick(event) {
      const target = event.target;
      if (typeof target?.closest !== 'function') return;
      // Resolve the actual tapped cell/selection circle, never an absolute
      // hit-area on a table row. Keyboard activation still uses the real button.
      const row = target.closest('[data-size-row]');
      if (row && this.contains(row) && row.closest('dime-ring-size') === this) {
        const value = row.dataset.sizeRow;
        if (!this.dialog.open || !/^(?:[89]|[12][0-9]|30)$/.test(value)) return;
        event.preventDefault();
        event.stopPropagation();
        this.input.value = value;
        this.input.dispatchEvent(new Event('change', {bubbles:true}));
        this.refreshSelection();
        const productForm = this.closest('product-form');
        const error = productForm?.querySelector('.product-form__error-message');
        if (error?.textContent === this.input.dataset.error && typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage();
        this.dialog.close();
        return;
      }
      const control = target.closest('button');
      if (!control || !this.contains(control)) return;
      if (control.hasAttribute('data-open-sizes')) this.open('sizes');
      if (control.hasAttribute('data-open-guide')) this.open('guide');
      if (control.hasAttribute('data-close-size')) this.dialog.close();
      if (control.hasAttribute('data-back-sizes')) this.setTab('sizes', true);
      if (control.dataset.sizeTab) this.setTab(control.dataset.sizeTab, true);
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.body.style.overflow = this.oldOverflow ?? '';
      }
    }
    open(tab='sizes') {
      this.setTab(tab);
      this.refreshSelection();
      this.returnFocus = document.activeElement;
      if (!this.dialog.open) {
        this.oldOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      }
      this.querySelector(`[data-size-tab="${tab}"]`).focus();
    }
    setTab(tab, focus=false) {
      const name = tab==='guide'?'guide':'sizes';
      for (const button of this.querySelectorAll('[data-size-tab]')) {
        const active = button.dataset.sizeTab===name;
        button.setAttribute('aria-selected',String(active));
        button.tabIndex=active?0:-1;
        if(active && focus) button.focus();
      }
      for(const panel of this.querySelectorAll('[data-size-panel]')) panel.hidden=panel.dataset.sizePanel!==name;
    }
    refreshSelection() {
      const value = this.input.value;
      this.querySelector('[data-size-value]').textContent = value ? `${value} (TR)` : this.dataset.language==='tr'?'Ölçü seçin':'Select size';
      for (const row of this.querySelectorAll('[data-size-row]')) {
        const selected = row.dataset.sizeRow===value;
        row.toggleAttribute('data-selected',selected);
        row.querySelector('button').setAttribute('aria-pressed',String(selected));
      }
    }
    updateCountry() {
      const reference = [
        [48,4.5,'I ½'],[49.3,5,'J ½'],[50.6,5.5,'L'],[51.9,6,'M'],
        [53.1,6.5,'N'],[54.4,7,'O'],[55.7,7.5,'P'],[57,8,'Q'],
        [58.3,8.5,'R'],[59.5,9,'S'],[60.8,9.5,'T'],[62.1,10,'T ½'],
        [63.4,10.5,'U ½'],[64.6,11,'V ½'],[65.9,11.5,'W ¾'],
        [67.2,12,'Y'],[68.5,12.5,'Z'],[69.7,13,'Z+1']
      ];
      const system=this.country.value;
      for(const row of this.querySelectorAll('[data-size-row]')) {
        const tr=Number(row.dataset.sizeRow), circumference=tr+40;
        const nearest=reference.reduce((a,b)=>Math.abs(b[0]-circumference)<Math.abs(a[0]-circumference)?b:a);
        let value=String(tr);
        if(system==='eu') value=String(circumference);
        if(system==='de') value=(circumference/Math.PI).toFixed(1);
        if(system==='us') value=`≈ ${nearest[1]}`;
        if(system==='uk') value=`≈ ${nearest[2]}`;
        row.querySelector('[data-local-size]').textContent=value;
      }
    }
  });
}
